import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FirebaseNotificationIntialValues,
  FirebaseNotificationValidationSchema,
} from "../../constant";
import { useMutateEditFirebaseNotification } from "../../hooks/useApiHook";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import { useQuery } from "@tanstack/react-query";
import InputWithLabel from "../../../../Components/InputWithLabel";
import TextArea from "../../../../Components/TextArea";
import { GetSingleFirebaseNotification } from "../../../../Api/firebasenotifications";
import BackButton from "../../../../Components/BackButton";
import SaveButton from "../../../../Components/SaveButton";
import Select from "react-select";
import { getNotificationDayOptions, getPhaseOptions } from "../../../../Utils/Helper";

const EditFirebaseNotifications = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const stateData = useLocation();

  const { id } = stateData?.state || "";

  const editFirebaseNotificationsApi = useMutateEditFirebaseNotification();
  const [isLoading, setIsLoading] = useState(false);

  const { data } = useQuery({
    queryKey: ["get-single-firebase-notifications", id],
    queryFn: () => GetSingleFirebaseNotification({ id }),
    onError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");

    },
  });

  useEffect(() => {
    if (data) {
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          phase: data?.data?.phase || null,
          title: data?.data?.title,
          message: data?.data?.message,
          day: data?.data?.day,
        });
      }
    }
  }, [data]);

  const handleSubmitEditNotification = (values) => {
    const reqData = {
      id,
      data: {
        phase: values?.phase,
        title: values?.title,
        message: values?.message,
        day: values?.day,
      },
    };

    setIsLoading(true);
    editFirebaseNotificationsApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || "Notification Updated.");
        navigate("/admin/push-notifications");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };

  return (
    <>
      <Helmet>
        <title>OVE | Admin Edit Push Notifications</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border overflow-visible">
                <div className="card-body">
                  {/* Header */}
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Edit Push Notifications</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/push-notifications" />
                      </div>
                    </div>
                  </div>

                  {/* Form Section */}
                  <section className="section-border">
                    <Formik
                      initialValues={{ ...FirebaseNotificationIntialValues, phase: "" }}
                      validationSchema={FirebaseNotificationValidationSchema}
                      validateOnChange
                      onSubmit={handleSubmitEditNotification}
                      innerRef={formRef}
                    >
                      {(formik) => (
                        <Form>
                          <div className="row">
                            {/* Row 1: Phase and Day */}
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Phase</label><span className='text-danger'> *</span>
                                <Select
                                  options={getPhaseOptions()}
                                  placeholder="Select Phase"
                                  value={getPhaseOptions().find(o => o.value === formik.values.phase) || null}
                                  onChange={(option) => {
                                    formik.setFieldValue("phase", option ? option.value : null);
                                    formik.setFieldValue("day", null);
                                  }}
                                  isClearable={false}
                                />
                              </div>
                              <ErrorMessage name="phase" component="div" className="text-danger" />
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Day</label><span className='text-danger'> *</span>
                                <Select
                                  options={formik.values.phase ? getNotificationDayOptions(formik.values.phase) : []}
                                  placeholder={formik.values.phase ? "Select Day" : "Select Phase first"}
                                  value={(formik.values.phase ? getNotificationDayOptions(formik.values.phase) : [])
                                    .find((o) => o.value === formik.values.day) || null}
                                  onChange={(option) => {
                                    formik.setFieldValue("day", option ? option.value : null);
                                  }}
                                  isDisabled={!formik.values.phase}
                                  isClearable={false}
                                />
                              </div>
                              <ErrorMessage name="day" component="div" className="text-danger" />
                            </div>

                            {/* Row 2: Title and Message */}
                            <div className="col-md-6 mt-3">
                              <Field
                                Label="Title"
                                type="text"
                                name="title"
                                placeholder="Enter Title"
                                component={InputWithLabel}
                              />
                            </div>
                            <div className="col-md-6 mt-3">
                              <Field
                                Label="Message"
                                name="message"
                                placeholder="Enter Message"
                                component={TextArea}
                              />
                            </div>
                          </div>

                          {/* Save Button same as AppNotification */}
                          <SaveButton loading={isLoading} />
                        </Form>
                      )}
                    </Formik>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditFirebaseNotifications;
